import { useEffect, useRef, useState } from "react";
import { Expand, ExternalLink, X } from "lucide-react";
import { LocalImage } from "./LocalImage";

export const TechnicalImage = ({ item, className = "" }) => {
  const dialogRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (open) dialogRef.current?.showModal();
  }, [open]);

  if (failed) return null;

  return (
    <figure className={`technical-frame min-w-0 ${className}`}>
      <button type="button" onClick={() => setOpen(true)}
        aria-label={`${item.title} vergrößern`}
        className="group block w-full text-left focus-visible:outline-offset-4">
        <span className="flex items-center justify-between gap-3 border-b border-white/10 px-4 sm:px-5 py-4">
          <span className="font-mono text-[10px] sm:text-xs uppercase tracking-wider text-white/60">{item.label}</span>
          <Expand size={15} className="shrink-0 text-brand-light group-hover:text-white transition-colors" />
        </span>
        <span className="technical-image block bg-black p-2 sm:p-4">
          <LocalImage src={item.src} alt={item.alt} width={item.width} height={item.height}
            onError={() => setFailed(true)} className="block w-full h-full object-contain" />
        </span>
      </button>
      <figcaption className="flex flex-wrap items-center justify-between gap-2 border-t border-white/10 px-4 sm:px-5 py-4">
        <span className="font-display text-xs sm:text-sm font-medium text-white/80">{item.title}</span>
        <span className="font-mono text-[10px] text-white/40">Originalaufnahme</span>
      </figcaption>

      <dialog ref={dialogRef} onClose={() => setOpen(false)} aria-label={item.title}
        className="image-dialog" data-lenis-prevent>
        <div className="flex items-center justify-between gap-4 border-b border-white/10 px-4 py-3">
          <p className="font-mono text-xs text-white/70">{item.title}</p>
          <button type="button" onClick={() => dialogRef.current.close()} aria-label="Bildansicht schließen"
            className="flex h-11 w-11 shrink-0 items-center justify-center text-white/70 hover:text-white">
            <X size={22} />
          </button>
        </div>
        {open && <LocalImage src={item.src} alt={item.alt} loading="eager" className="block w-full max-h-[75svh] object-contain bg-black" />}
        <a href={item.src} target="_blank" rel="noreferrer"
          className="flex items-center justify-center gap-2 px-4 py-4 font-mono text-xs text-brand-light hover:text-white">
          Original in voller Größe öffnen <ExternalLink size={14} />
        </a>
      </dialog>
    </figure>
  );
};
